export const trans_IT = {
    mainTitle: "Area clienti Mi Piace Così",
    calendarScreen: {
        helper: "Selezionate il giorno di consegna desiderato tra quelli evidenziati in rosa",
        actualDate: "Data di consegna programmata",
        initialDate: "Data di consegna iniziale",
        error: {
            sameDate: "La data selezionata è identica alla data prevista.",
            responseError: "Servizio non disponibile.",
            wsError: "Il servizio è temporaneamente non disponibile.",
            empty: "Selezionate la data di consegna desiderata."
        },
        modal: {
            validationText: "Desiderate programmare la data di consegna del vostro prossimo pacco per il:",
            confirmationText: "La data di consegna del vostro prossimo pacco è ora programmata per il:"
        },
        mentions: {
            mention1: "Potete posticipare il vostro pacco se la data di consegna prevista è tra",
            mention1strong: "almeno 3 giorni.",
            mention2: "Potete posticipare o anticipare la data di consegna del vostro pacco entro",
            mention2strong: "l'intervallo di date indicato in rosa.",
            mention3: "Se desiderate posticipare la ricezione del vostro pacco oltre questo periodo, vi preghiamo di contattare il servizio clienti al",
            mention3strong: "",
            mention4: "La data di consegna è stimata e potrebbe variare."
        },
        btn: "Posticipare la mia consegna",
        title: "Posticipo la data di consegna da:",
        cancel: "Annulla",
        modification: "Modificare",
        close: "Chiudi",
        validation: "Convalida"
    },
    url:{
        login: "connessione",
        register: "registrazione",
        recovery: "parola d'ordine",
        home: "benvenuto",
        success: "i_miei_successi",
        program: "il_mio_coaching",
        habit: "le_mie_abitudini",
        profile: "le_mie_impostazioni",
        activities: "i_miei_esercizi",
        advices: "i_miei_consigli",
        personalisation: "i_miei-piatti",
        personalisationCja: "la_mia_personalizzazione",
        resignation: "Risoluzione"
    },
    services:{
        email:{
            support: "clienti@mipiacecosi.it",
            customer: "clienti@mipiacecosi.it"
        },
        phone:{
            customer: "02/83595151",
            commercial: "02 83 59 51 51"
        },
    },
    btn:{
        valid: "Conferma",
        close: "Chiudi",
        confirmation: "Conferma",
        annulation: "Annulla",
        faq: "Consulto le faq",
        send: "Invia la mia richiesta",
        request: "Scrivo la mia richiesta",
        rdv: "posticipare il mio appuntamento"
    },
    label:{
        valid: "Convalida"
    },
    dates: {
        to: "da",
        the: "il",
        from: "Da",
        off: "a"
    },
    header:{
        title: "il mio spazio personale",
        sos: "SOS SGARRO",
        logout: 'Disconnettere'
    },
    footer:{
        help: "Hai bisogno di aiuto? Contattaci!",
        help2:{
            text1: "Bisogno",
            text2: "di Aiuto?"
        },
        time: "Il nostro servizio clienti è a vostra disposizione dal lunedì al venerdì, dalle 9 alle 19",
        contact: {
            title: "servizio clienti",
            phone: "Per telefono",
            email: "Per e-mail"
        },

        copyright: "© 2025 Comme J’aime Italia -Tutti i diritti riservati"
    },
    navBar: {
        hello: "Buongiorno"
    },
    pages:{
        resignation:{
            title: "Risoluzione",
            description: "Risoluzione di un contratto"
        },
        personalisation:{
            title: "I miei piatti",
            description: "Per personalizzare i piatti del tuo prossimo invio"
        },
        connection:{
            title: "Accedi",
            email: {
                title: "Il tuo indirizzo e-mail",
                subTitle: "Inserisci il tuo indirizzo email nel campo sottostante per accedere al tuo spazio",
                placeholder: "La tua email"
            },
            password:{
                placeholder: "La mia password",
                title: "La mia password",
                sub1: "Inserisci la password associata al tuo account",
                mdpForgotten: "Hai dimenticato la password",
                btnLabel: "Conferma"
            },
            renewPassword:{
                placeholder:{
                    newPassword: "La tua nuova password",
                    repeatPassword: "Conferma password"
                },
                title: "La tua nuova password",
                textSubTitle1: "Per una maggiore sicurezza, si prega di cambiare la password.",
                textSubTitle2: "Si prega di assicurarsi che includa almeno:"
            },
            forgetPassword: {
                title: "Hai dimenticato la password",
                text: "Un'e-mail contenente una nuova password verrà inviata al seguente indirizzo:",
                success: "Nuova password inviata!",
                successText: "Controlla la tua casella di posta elettronica per scoprire la tua nuova password e accedi con essa."
            },
            legal: {
                title: "Condizioni generali di utilizzo"
            },
        },
        legal:{
            title: "Le nostre condizioni d'uso",
            sub: "La sicurezza dei tuoi dati è al centro delle nostre priorità. Per completare la registrazione, si prega di selezionare le caselle seguenti:",
            read: "Li ho letti e li accetto",
            textCgu: "Condizioni Generali d'Uso e Carta per la Protezione dei Dati Personali",
            textInfos: "Accetto di ricevere informazioni sui Programmi COMME J'AIME grazie ai miei dati personali trasmessi nell'area clienti, nell'applicazione o dalla bilancia collegata",
            labelBtn: "Convalida"
        },
        registration: {
            title: "Registrazione"
        },
        recovery:{
            title: "Password"
        },
        home:{
            title: "Benvenuto",
            text1: "Benvenuto nella tua area personale,",
            text2: "Seleziona la funzione a cui desideri accedere.",
            app:{
                title: "Scarica l'app COMME J’AIME",
                subTitle: "per sfruttare più funzionalità",
                intro: "Oltre alle sessioni con il tuo coach, l'app COMME J'AIME è IL supporto essenziale per il tuo progetto di perdita di peso.",
                arg1: "Tieni traccia del tuo peso e delle tue misure",
                arg2: "Ammira la trasformazione della tua silouette",
                arg3: "Pratica attività fisica adattata",
                arg4: "Adotta buone abitudini"
            },
        },
        success:{
            slug: "successo",
            title: "I miei progressi",
            menu: "I miei progressi",
            description: "Per seguire la mia curva del peso con facilità.",
            graph: {
                year: "Anno",
                month: "Mesi",
                week: "Settimana",
                all: "Tutto",
                measures: "Tutte le pesate",
                menu: "Le mie classifiche",
                average: "Nella media",
                unit: "kg",
                views: {
                    year: "Visione annuale",
                    month: "Visualizzazione mensile",
                    week: "Visualizzazione settimanale"
                },
                infos: {
                    title: {
                        text1: "Inserisci il tuo peso dal",
                        text2: "la nostra app mobile!"
                    },
                    sub: {
                        text1: "Scarica la nostra app COMME J'AIME per inserire il tuo peso e trovare la tua curva di peso e le tue evoluzioni sopra!"
                    },
                },
                measure: {
                    empty: "Non avete alcuna misura",
                    error: "Si è verificato un errore, non possiamo recuperare le tue informazioni."
                },
                evolution: {
                    my: "Ma",
                    first: "primo",
                    last: "ultimo",
                    fluctuation: "Oscillazioni",
                    weight: "peso",
                    mine: "Mio",
                    actual: "corrente",
                    startProgram: "dall'inizio del programma",
                    startYear: "nel corso dell'anno",
                    startMonth: "nel corso del mese",
                    startWeek: "durante la settimana",
                    scaleStartProgram: "pesato dall'inizio del programma",
                    scaleYear: "peso dell'anno",
                    scaleMonth: "pesata del mese",
                    scaleWeek: "Pesata della settimana"
                }
            },
        },
        activities:{
            slug: "attività",
            title: "I miei esercizi fisici",
            menu: "I miei esercizi",
            description: "Praticare facilmente un'attività fisica adattata.",
            textTitle1: "Inizia",
            textTitle2: "Un programma di attività fisica!",
            textSubtitle1: "In un periodo di diradamento, è",
            textSubtitle2: "indispensabile per esercitare un'attività",
            textSubtitle3: "fisico al fine di",
            textSubtitle4: "mantenere la massa muscolare",
            textSubtitle5: "e",
            textSubtitle6: "Mantieni il tuo peso target a lungo termine.",
            textApp1: "Scarica la tua",
            textApp2: "App MI PIACE COSI'!",
            textExercise1: "+ di",
            textExercise2: "500 esercizi",
            textExercise3: "attività fisica adattata",
            textProgression1: "Una progressione crescente",
            textProgression2: "adattato al tuo profilo",
            textTransformation1: "Una trasformazione",
            textTransformation2: "del tuo corpo assicurata",
            textRewards1: "Ricompense",
            textRewards2: "da sbloccare per rimanere motivati",
            textStart1 :"Ed eccoci qui",
            textStart2 :"massimo 10 mn",
            textStart3 :"di esercizio fisico al giorno!",
            textAvailable: "Presto disponibile nella tua area clienti!"
        },
        program:{
            slug: "programma",
            title: "Il mio coaching",
            menu: "Il mio coaching",
            description: " Per fissare appuntamenti con il mio coach esperto in dietetica.",
            rdv: {
                title: {
                    text1: "Il mio prossimo",
                    text2: "appuntamento di coaching"
                },
                noRdv: "Non hai un appuntamento in arrivo.  Contatta il tuo Servizio Clienti per fissare un appuntamento con il tuo Coach Esperto di Dieta!",
                modal: {
                    the: "il",
                    change: {
                        title: "Modifica del tuo prossimo appuntamento con il coach",
                        sub1: "Il tuo prossimo appuntamento con il coach è fissato",
                        sub2: "Seleziona la data e l'ora a cui vuoi spostarlo."
                    },
                    reservation: {
                        text1: "Desidera fissare un appuntamento il: "
                    },
                    confirmation: {
                        text1: "Il tuo cambio di appuntamento  è stato preso in considerazione.",
                        text2: "Appuntamento il"
                    },
                    error: {
                        text1: "Il tuo coach non ha disponibilità per questa settimana"
                    },
                    empty: {
                        text1: "Purtroppo il tuo coach non è più disponibile",
                        text2: "Ti invitiamo a contattare il vostro servizio clienti"
                    },
                    actual: "Il tuo appuntamento",
                }
            },
        },
        habit:{
            slug: "abitudini",
            title: "Le mie abitudini",
            menu: "Le mie abitudini",
            description: "Adottare buone abitudini quotidianamente.",
            intro:{
                text1: "Adottane di nuovi",
                text2: "Buone abitudini",
                text3: "in modo semplice e unico",
                text4: "Qualche giorno!"
            },
            goal: "Obiettivo: raggiungere il tuo peso ideale e mantenerlo a lungo termine!",
            block1: {
                text1: "Abbiamo creato per te",
                text2: "36 buone abitudini",
                text3: "per",
                text4: "mangiare bene",
                text5: "muoverti di più",
                text6: "e",
                text7: "conoscerti meglio"
            },
            advice: {
                exhausted: {
                    text1: "Sei stanco?",
                    text2: "Non dimagrisci facilmente?",
                    text3: "Adotta l'abitudine giusta",
                    text4: "Bevo 1,5 litri di acqua al giorno"
                },
                hunger: {
                    text1: "Sei abituato a compensare le tue emozioni con il cibo?",
                    text2: "Adotta l'abitudine giusta",
                    text3: "Tengo un taccuino delle emozioni"
                }
            },
            application: "Scarica subito la nostra app per adottare le tue nuove buone abitudini!"
        },
        profile:{
            slug: "profilo",
            title: "Le mie impostazioni",
            menu: "Le mie impostazioni",
            email: "La tua richiesta è stata inviata al Servizio Clienti.",
            description: "Per modificare i miei dati e informazioni.",
            resignation: {
                title: "Richiesta di",
                titleColor: "annullamento",
                link:  "Annulla il mio abbonamento"
            },
            data:{
                menu: "I miei dati",
                header: {
                    title: {
                        text1: "Modifica di alcune",
                        text2: "informazioni"
                    },
                    text: "Per motivi di sicurezza, si prega di contattare il servizio clienti per modificare alcune informazioni (indirizzo e-mail, numero di telefono, dati di fatturazione).",
                    label: {
                        phone: "Per telefono",
                        email: "Per e-mail"
                    }
                },
                personal: {
                    title1: "Dati",
                    title2: "personale",
                    textGender: "Tu sei:",
                    label:{
                        male: "Signore",
                        female: "Signora",
                        record: "Salva modifiche",
                        success: "Le tue informazioni sono state modificate",
                        birthdate: "Data di nascita:"
                    },
                },
                infos: {
                    title: {
                        text1: "Informazioni",
                        text2: "legale"
                    },
                    label: {
                        cgv: "Condizioni Generali di Vendita"
                    },
                    link: "Consultare"
                },
                general:{
                    title1: "Dati",
                    title2: "generale",
                    refCustomer: "Il tuo codice cliente:",
                    phoneCustomer: "Il tuo numero di telefono:",
                    emailCustomer: "Il tuo indirizzo email:",
                    mdpCustomer: "Cambia la tua password:",
                    mdp:{
                        form:{
                            placeholder:{
                                oldMdp: "La tua password attuale",
                                newMdp: "La tua nuova password",
                                confMdp: "Conferma la tua password"
                            },
                        },
                        title: "Modifica della password",
                        textActualMdp: "Per poter modificare la password, inserisci la tua password attuale:",
                        textNewMdp1: "Inserisci la tua nuova password.",
                        textNewMdp2: "Assicurati che includa almeno:",
                        textRequireLength: "8 caratteri",
                        textRequireMin: "1 minuscolo",
                        textRequireNumber: "1 figura",
                        textRequireMaj: "1 lettera maiuscola",
                        textSamePassword: "Password identiche",
                        textOldPassword: "Password corrente",
                        mdpSuccess: "La tua password è stata modificata"
                    },
                },
                billing: {
                    title: {
                        text1: "Dati",
                        text2: "fatturazione"
                    },
                    firstname: "Cognome:",
                    lastname: "Nome:",
                    address: "Indirizzo:",
                    code: "Codice postale:",
                    city: "Città:",
                    country: "Paese:"
                },
            },
            command: {
                multi: "Si prega di contattare il servizio clienti",
                menu: "I miei ordini",
                status: {
                    title: "Stato",
                    upcoming: "Prossimamente",              //1
                    preparation: "In preparazione",         //2
                    send: "Spedito",                        //3
                    wait: "In sospeso",                     //4
                    refused: "Rifiutato",                   //5
                    returned: "Ribaltato",                  //6
                    canceled: "Annullato",                  //7
                    delivered: "Consegnato",                //8
                    started: "Iniziato il",
                    ended: "Finito il"
                },
                delivery: "Consegna",
                rank: "Invio",
                expedition: "Spedizione",
                follow: "Tracciamento del pacco",
                payment: "Prelievo",
                price: "Importo",
                invoice: "Documento",
                next: {
                    text1: "La mia prossima",
                    text2: "spedizione"
                },
                date: {
                    delivery: "Data di spedizione:",
                    deliveryExpected: "Data dell'addebito diretto:",
                    expedition: "Date d'expedition :",
                    payment: "Date de prélèvement :"
                },
                equ: {
                    title: "I miei ordini Equilibrio"
                },
                cja: {
                    title: "I miei ordini Mi Piace Così"
                },
                cpl: {
                    title: "I miei ordini di integratori alimentari"
                }
            },
            help: {
                menu: "Aiuto e assistenza",
                title: {
                    text1: "Hai una",
                    text2: "domanda"
                },
                faq: "Dai un'occhiata alle nostre FAQ, ci sono buone probabilità che troverai la risposta alla tua domanda!",
                noAnswer: {
                    text1: "Non hai trovato",
                    text2: "la risposta",
                    text3: "Alla tua domanda?"
                },
                send: "Inviaci un'e-mail utilizzando il nostro modulo di contatto.",
                form: "Inizia selezionando l'argomento della tua domanda:",
                themes: {
                    ap: "l'app mobile",
                    scale: "la bilancia",
                    coaching: "il coaching",
                    cpl: "integratori alimentari",
                    ec: "l'area clienti",
                    delivery: "spedizioni e consegne",
                    payment: "pagamento e fatturazione",
                    refund: "Resi e rimborsi",
                    meals: "i piatti",
                    end: "Annullamento",
                    other: "Un altro motivo"
                },
                subject: {
                    title: "Ci contatti per",
                    sub: "Scegli il motivo della tua richiesta",
                    other: "Altro",
                    mobile: {
                        connection: "Accedi",
                        graphs: "Le mie classifiche",
                        pictures: "Le mie foto",
                        fitness: "Fitness",
                        habit: "Buone abitudini",
                        info: "Informazioni sul cliente"
                    },
                    scale: {
                        hs: "Fallimento",
                        pair: "Errore di associazione",
                        data: "Dati",
                        reception: "Ricezione"
                    },
                    coaching: {
                        rdv: "Sposta / Annulla un appuntamento",
                        coach: "Cambia coach",
                        advice: "Ottenere consigli dietetici"
                    },
                    cpl: {
                        request: "Richiesta di informazioni",
                        reception: "Ricezione",
                        return: "Resi"
                    },
                    ec: {
                        connection: "Accedi",
                        graphs: "Grafica",
                        rdv: "Nomina del coach"
                    },
                    delivery: {
                        missing: "Ordine non ricevuto",
                        report: "Spostamento una consegna",
                        damaged: "Pacco danneggiato"
                    },
                    payment: {
                        payment: "Paga un ordine",
                        bill: "Essere informati sulla mia situazione contabile o sulla mia fatturazione"
                    },
                    refund: {
                        return: "Come effettuare un reso",
                        info: "Avere informazioni su un reso in corso",
                        refund: "Essere informato sul mio rimborso"
                    },
                    meals: {
                        infos: "Segnalare informazioni"
                    },
                    cancellation: {
                        end: "Annulla il mio abbonamento"
                    },
                },
                email: {
                    subject: "Ci contatti per",
                    details: "Al fine di risparmiare tempo nell'elaborazione del tuo file, ti preghiamo di comunicarci esattamente i dettagli della tua richiesta.",
                    picture: "Non esitate ad allegare una foto per completare la vostra richiesta (massimo 3 foto).",
                    placeholder: {
                        subject: "Inserisco il motivo del mio messaggio",
                        message: "Inserisco qui il mio messaggio"
                    },
                    label: "Allega una foto",
                    success: "La tua richiesta è stata inoltrata al servizio clienti"
                },
            },
        },
        advice: {
            slug: "consiglio",
            title: "I miei consigli",
            menu: "I miei consigli",
            description: "Per aiutarmi durante e dopo il mio programma."
        },
        sosBreaking:{
            slug: "SOS",
            title:"SOS SGARRO",
            description: " Per avere supporto quando sto per crollare.",
            btn:{
                prevQuestion: "Domanda precedente",
                nextQuestion: "Prossima domanda",
                breakDown: "Ho ceduto",
                sendSos: "Invia questo SOS",
                angryOk: "Non ho più fame",
                desireOk: "La voglia è svanita"
            },
            questions: {
                text1: "Stai per crollare e sgarrare?",
                text2: "Siamo qui per sostenerti!",
                text3: 'Capire l\'origine di un "cedimento" è fondamentale per affrontarlo.',
                text4: "Per fare questo, ti faremo 4 domande per aiutarti a resistere nel miglior modo possibile!"
            },
            results:{
                text1: "Per mettere tutte le possibilità dalla tua parte, ecco i consigli che ti consigliamo di seguire quando stai per crollare in questo tipo di situazione"
            }
        },
        eLearning: {
            title: "I miei quiz sulla salute",
            sub: "Per mettere alla prova la mia conoscenza delle guide MI PIACE COSI'"
        }
    },
    errors:{
        service: "Il servizio è temporaneamente non disponibile",
        advices: "La consulenza non è disponibile",
        personalisation: "La personalizzazione non è disponibile",
        login: {
            email:{
                notValid: "Inserisci un indirizzo e-mail valido.",
                blank: "Inserisci un indirizzo e-mail.",
                unknown: {
                    text1: "L'indirizzo",
                    text2: "non è riconosciuto",
                    text3: "Sei un cliente MI PIACE COSI'",
                    text4: "E il tuo indirizzo email non viene riconosciuto?",
                    text5: "Contatto",
                    text6: "Non sei un cliente MI PIACE COSI'?",
                    text7: "E vuoi maggiori informazioni?",
                    text8: "Contattaci all'indirizzo",
                },
            },
            password:{
                blank: "Inserisci la tua password.",
                incorrectMdp: "La password inserita non è corretta.",
                issue: "Ooops Qualcosa è andato storto.",
                notAvailable: "Il servizio non è disponibile"
            },
            newPassword: {
                blank: "Inserisci la tua nuova password in ciascuno dei campi.",
                toShort: "Controlla che la tua nuova password sia lunga almeno 8 caratteri."
            },
            repeatPassword: {
                blank: "Inserisci nuovamente la tua nuova password.",
                notSame: "Verificare la conformità tra le due password inserite."
            },
            cguNoChecked: "Si prega di accettare i T&C"
        },
        profile: {
            data: {
                failed: "L'aggiornamento non è riuscito",
                failed2: "si è verificato un errore",
                birthday:{
                    blank: "Inserisci la tua data di nascita"
                },
            },
            command: {
                error: "Non riusciamo a visualizzare i tuoi ordini"
            },
            help: {
                format: "I formati accettati per le foto sono png o jpeg",
                size: "La dimensione massima delle foto è di 5 MB",
                noMessage: "Si prega di compilare la richiesta nel campo dedicato.",
                noSubject: "Si prega di inserire il motivo della richiesta nell'apposito campo"
            }
        }
    }
}
